const isLoaded = (win = window) => !!win.__KlarnaNativeHook

export default isLoaded
